import React from 'react';
import Icon, { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { theme } from '@tools/ui-utils/theme.util';

export type SVGComponent = React.ComponentType<
  React.PropsWithChildren<CustomIconComponentProps | React.SVGProps<SVGSVGElement>>
>;

type IProps = { style?: React.CSSProperties; component: unknown };

const IconWrap: React.FC<React.PropsWithChildren<IProps>> = ({ style, component }) => {
  const defaultStyle = {
    fontSize: 18,
    color: theme.colors.gray.gray45,
    ...style,
  };
  return <Icon component={component as SVGComponent} style={defaultStyle} />;
};

export default IconWrap;
